import { useAuth } from './useAuth';
import { useOrganization } from './useOrganization';

/**
 * True when the active org holds the given capability slug. Capabilities are
 * per-org entitlements (granted by a super-admin) that gate whole features.
 *
 * Mirrors the server: a single-tenant / auth-disabled self-host has no org
 * entitlement concept, so everything is allowed. With auth on, the answer is
 * strictly the active org's capability set — capabilities are not bypassed by
 * platform admins, matching the server-side route gate.
 */
export function useHasCapability(capability: string): boolean {
  const { authEnabled } = useAuth();
  const { activeOrganization } = useOrganization();
  if (!authEnabled) return true;
  return activeOrganization?.capabilities?.includes(capability) ?? false;
}
